import { bool, node } from "prop-types";
import { CSSTransition } from "react-transition-group";
import styled from "styled-components/macro";

// TO-DO: Figure out a way to implement nodeRefs
// for CSSTransition in order to silence
// findDOMNode deprecated warnings in strict mode
const FadeInTransition = ({ children, isIn = false, ...rest }) => (
  <TransitionItem>
    <CSSTransition
      classNames="transition"
      in={isIn}
      timeout={1000}
      unmountOnExit
    >
      {children}
    </CSSTransition>
  </TransitionItem>
);

FadeInTransition.propTypes = {
  children: node.isRequired,
  isIn: bool,
};

export default FadeInTransition;

const TransitionItem = styled.div`
  .transition-enter {
    opacity: 0;
  }
  .transition-enter-active {
    opacity: 1;
    transition: opacity 1s;
  }
  .transition-exit {
    opacity: 1;
  }
  .transition-exit-active {
    opacity: 0;
    transition: opacity 1s;
  }
`;
